import { createSlice } from '@reduxjs/toolkit'
import { renameTask } from '../../components/meeting/list/types/task/details/slice'

const initialState = {
  data: {
    name: '',
  },
  openForm: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'renameMeetingTypeTask',
  initialState,
  extraReducers(builder) {
    builder.addCase(renameTask.fulfilled, () => initialState)
  },
  reducers: {
    formInit: (state, action) => {
      state.data.name = action.payload.name
    },
    changeName: (state, action) => {
      state.data.name = action.payload.name
    },
    setOpenForm: (state, action) => {
      state.openForm = action.payload.openForm
    },
    resetForm: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.renameMeetingTypeTask
export const selectFormData = (state) => selectSlice(state).data
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status
export const selectOpenForm = (state) => selectSlice(state).openForm

const { reducer, actions } = slice

export const { changeRequestStatus, formInit, resetForm, changeName, setOpenForm } = actions

export default reducer
